
import Vue from "vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Costs from "../components/ship/steps/Costs.vue";
import Search from "../components/ship/steps/Search.vue";
import LoaderPayment from "~/components/LoaderPayment.vue";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import LargeSelect from "~/components/form/LargeSelect.vue";
import SmallRoundedSelect from "~/components/form/SmallRoundedSelect.vue";
import BoxCaseForm from "~/components/ship/BoxCaseForm.vue";
import StageForm from "~/components/ship/StageForm.vue";
import Contents from "~/components/ship/steps/Contents.vue";
import Details from "~/components/ship/steps/Details.vue";
import Payment from "~/components/ship/steps/Payment.vue";

export default Vue.extend({
  name: "Ship",
  components: {
    SmallRoundedSelect,
    LargeSelect,
    StageForm,
    BoxCaseForm,
    Search,
    Costs,
    Details,
    Contents,
    Payment,
    LoaderSpinner,
    LoaderPayment
  },
  layout: "WithServices",
  data() {
    return {
      title:
        "Bicycle Shipping | Bike Shipping | Shipping A Bike | Ship A Bike | Bikeflights.com",
      flushCaller: "ship",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "shipping",
          name: "shipping",
          content:
            "Ship your bike, wheels or gear with confidence. You get fast delivery, great prices and excellent service with every shipment per our Best Way Guarantee.",
        },
      ],
      script: [
        {
          src: "https://js.stripe.com/v3/",
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href: `styles/${
            this.stepName === "Payment" ? "payment" : "default"
          }.css`,
        },
      ],
    };
  },
  computed: {
    // Vuex getters
    ...mapGetters({
      loading: "loading",
      secondaryLoading: "secondaryLoading",
      session: "user/session",
      stepNumber: "ship/stepNumber",
      stepName: "ship/stepName",
    }),
  },

  methods: {
    ...mapMutations({
      flushShipStore: "ship/flush",
      flushPaymentStore: "payment/flush",
      clearContentsOnDestroy: "ship/clearContentsOnDestroy",
      clearOrderDetailsOnDestroy: "payment/clearOrderDetailsOnDestroy",
    }),
    ...mapActions({
      setStep: "ship/setStep",
      startSession: "user/startSession",
      clearActiveNotices: "errorsBag/clearActiveNotices",
    }),
    changeStep(step) {
      this.setStep(step);
    },
    goStep(stepName, valid) {
      if (valid) {
        this.changeStep(stepName);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // access to component public instance via `vm`
      if (vm) {
        if (from && from.name == "bicycleshops") {
          (vm as any).flushCaller = "bicycleshops";
        } else {
          if (from && from.name !== "ship") {
            (vm as any).clearActiveNotices();
          }
          (vm as any).flushCaller = "ship";
        }
        (vm as any).flushShipStore((vm as any).flushCaller); // call payment flusher too
        (vm as any).flushPaymentStore((vm as any).flushCaller);
      }
    });
  },
  fetchOnServer: true,
  beforeDestroy() {
    if (this.stepNumber > 1) {
      this.setStep(1);
      if (this.$route.path != "/confirmation") {
        this.clearContentsOnDestroy();
        this.clearOrderDetailsOnDestroy();
      }
    }
  },
});
